module.exports = __webpack_public_path__ + "img/智慧警务-物联网智慧平安小区管理平台V2.0.a7ae2013.jpg";